import React from 'react';
import BillingPortalPage from '../domains/billing/components/BillingPortalPage';

const BillingPortal: React.FC = () => {
  return <BillingPortalPage />;
};

export default BillingPortal;

